// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../addYears/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var addYears = convertToFP(fn, 2);
export default addYears;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/addYears/index.js
// module id = 819
// module chunks = 0